<!--
  Copyright (c) 2025 NoorWays. All rights reserved.
  Licensed under the terms specified in the LICENSE.txt file.
-->

<template>
  <div class="premium-benefits">
    <h4 v-if="showTitle" class="benefits-title">{{ $t('plan.premium.benefits.title') }}</h4>
    <ul class="benefits-list">
      <li v-for="benefit in premiumBenefits" :key="benefit" class="benefit-item">
        <span class="benefit-icon">✓</span>
        <span class="benefit-text">{{ $t(`plan.premium.benefits.${benefit}`) }}</span>
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">
interface Props {
  showTitle?: boolean
  compact?: boolean
}

withDefaults(defineProps<Props>(), {
  showTitle: true,
  compact: false,
})

// Premium benefits list - matches the extension's implementation
const premiumBenefits = ['unlimited', 'advanced', 'priority', 'exclusive']
</script>

<style lang="scss" scoped>
.premium-benefits {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.benefits-title {
  margin: 0;
  font-size: 1rem;
  font-weight: 600;
  color: var(--nw-text-primary);
}

.benefits-list {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.benefit-item {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  color: var(--nw-text-secondary);
  line-height: 1.5;
}

.benefit-icon {
  color: var(--nw-success);
  font-weight: bold;
  flex-shrink: 0;
  margin-top: 0.125rem;
}

.benefit-text {
  flex: 1;
}

/* Compact variant for smaller spaces */
.premium-benefits.compact {
  gap: 0.5rem;

  .benefits-title {
    font-size: 0.875rem;
  }

  .benefits-list {
    gap: 0.5rem;
  }

  .benefit-item {
    font-size: 0.875rem;
    gap: 0.5rem;
  }

  .benefit-icon {
    font-size: 0.875rem;
  }
}
</style>
